import { CommentState } from "./types";

export const commentStateInit: CommentState = {
  reactionsList: {},
  seensList: {},
  commentsList: {},
};

export default commentStateInit;
